import { createReducer, on } from "@ngrx/store";
import { MaintenanceScheduleStore } from "../../model/maintenance-schedule.model";
import { maintenanceScheduleActions } from "./maintenance-schedule.actions";

export const maintenanceScheduleInitialState: MaintenanceScheduleStore = {
    maintenanceDate: null,
    maintenanceIsActive: false,
    maintenanceRequestSuccess: false,
};

export const maintenanceScheduleReducer = createReducer(
    maintenanceScheduleInitialState,
    on(maintenanceScheduleActions.setCheckMaintenanceSchedule, (state, action): MaintenanceScheduleStore => {
        let returnValue: MaintenanceScheduleStore = { ...state, maintenanceRequestSuccess: action.successful };
        if (action.maintenanceDate === null) {
            returnValue = { ...returnValue, maintenanceDate: null, maintenanceIsActive: false };
        } else {
            const maintenanceStartMs = action.maintenanceDate.maintenanceStartDate.valueOf();
            const maintenanceEndMs = action.maintenanceDate.maintenanceEndDate.valueOf();
            const nowMs = Date.now();
            if (maintenanceStartMs > nowMs) {
                returnValue = { ...returnValue, maintenanceDate: action.maintenanceDate, maintenanceIsActive: false };
            } else if (maintenanceEndMs > nowMs) {
                returnValue = { ...returnValue, maintenanceDate: action.maintenanceDate, maintenanceIsActive: true };
            } else {
                returnValue = { ...returnValue, maintenanceDate: null, maintenanceIsActive: false };
            }
        }
        return returnValue;
    })
)